/**
 * Tax and gross amount from net amount and VAT rate, shared by invoices and offers (as
 * services/TaxAmountService.ts in apps/apolloserver). Rules of a single record type, e.g.
 * gross-only legacy invoices, stay in its form.
 */

export const DEFAULT_VAT_PERCENTAGE = 19;

const CENT_FACTOR = 100;

/** Rounds to cents; a non-finite value counts as 0. */
export const roundMoney = (value) => {
  if (!Number.isFinite(value)) {
    return 0;
  }
  return Math.round((value + Number.EPSILON) * CENT_FACTOR) / CENT_FACTOR;
};

/** Automatic mode (rate set): tax from net and rate; manual mode: the given tax amount. */
export const calculateTaxAmounts = ({ netAmount, vatPercentage, taxAmount }) => {
  const net = netAmount ?? 0;
  const tax =
    vatPercentage != null ? roundMoney((net * vatPercentage) / 100) : roundMoney(taxAmount ?? 0);

  return { taxAmount: tax, grossAmount: roundMoney(net + tax) };
};
